import { Injectable } from '@angular/core';
import {Personnel} from "../models/personnel";
import {HttpClient} from "@angular/common/http";
import {environment} from "@environments/environment";
import {RestApiManager} from './rest-api-manager';
import {Paginator} from "../models/paginator";
import PhoneNumber from "awesome-phonenumber";
import {AccountManagerService} from "./account-manager-service";

@Injectable({
  providedIn: 'root'
})
export class PersonnelManagerService {

  constructor(
    private accountManager: AccountManagerService,
    private httpClient: HttpClient,
    private restApiManager: RestApiManager,
  ) { }

  async getAllPersonnel(paginator?: Paginator<Personnel>): Promise<Personnel[]> {
    return this.restApiManager.getAll<Personnel>(
      Personnel,
      `${environment.restApi.endpoint}/companies/${this.accountManager.account.company.id}/users`,
      this.accountManager.account.authToken,
      { paginator }
    );

    // TODO set personnel available
    // Get all personnel
    /*const personnel = (await this.get(this.db.collection('companies').doc(this.accountManager.companyId).collection('personnel')) as QuerySnapshot).docs.map(doc => Personnel.fromJson(doc));
    // Get live availability status
    const promises = personnel.map(async (person: Personnel) => {
      person.available = await this.isPersonnelOnline(person);
      return person;
    })
    return Promise.all(promises);*/
  }

  async getPersonnel(personnelId: string): Promise<Personnel> {
    const personnel: Personnel = await this.restApiManager.get<Personnel>(Personnel, `${environment.restApi.endpoint}/users/${personnelId}`, this.accountManager.account.authToken);
    const phoneNumber = new PhoneNumber(personnel.phoneNumber);
    personnel.prefix = `+${phoneNumber.getCountryCode()}`;
    personnel.phoneNumber = personnel.phoneNumber.substr(personnel.prefix.length);
    return personnel;
  }

  async createPersonnel(personnel: Personnel): Promise<Personnel> {

    // Create personnel
    return this.restApiManager.post<Personnel>(
      `${environment.restApi.endpoint}/users`,
      { ...personnel, phoneNumber: `${personnel.prefix}${personnel.phoneNumber}`, companyId: this.accountManager.account.company.id },
      this.accountManager.account.authToken
    );

    // Set personnel role


  }

  async updatePersonnel(personnelId: string, personnel: Personnel): Promise<Personnel> {
    return this.restApiManager.put<Personnel>(
      `${environment.restApi.endpoint}/users/${personnelId}`,
      { ...personnel, phoneNumber: `${personnel.prefix}${personnel.phoneNumber}`, companyId: this.accountManager.account.company.id },
      this.accountManager.account.authToken
    );
  }

  async removePersonnel(personnelId: string): Promise<void> {
    return this.restApiManager.delete(
      `${environment.restApi.endpoint}/users/${personnelId}`,
      this.accountManager.account.authToken
    );
  }

  // TODO
  /*isPersonnelOnline(personnel: Personnel): Promise<boolean> {
    return from(this.angularFireDatabase.database.ref('fieldOperatorAvailability').child(personnel.id).once('value')).pipe(
      map(x => x.val() || false),
      take(1),
    ).toPromise();
  }*/

  async sendVideoCallNotification(personnel: Personnel, roomName: string) {
    /*const data = {
      "notification": {
        "title": "Videochiamata in arrivo",
        "body": "Clicca per rispondere alla videochiamata."
      },
      "data" : {
        "roomName": roomName,
        "chatId": 100,
        "ticketId": "potitohosting",
        "notification_type": "videocall"
      },
      "to": personnel.fcm_token,
    };
    return await this.httpClient.post('https://fcm.googleapis.com/fcm/send', JSON.stringify(data), {
      headers: {
        'Authorization': 'key=' + environment.firebaseMessagingKey,
        'Content-Type': 'application/json',
      }
    }).toPromise();*/
  }

}
